import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import { PORTAL_ESTABLISHMENTS_STATES_QUERY } from 'src/components/Pages/Orders/graphql';
import { Field } from 'react-final-form';


function EstablishmentsStatesSelect({ operatorId }) {
    const variables = {
        operatorId
    };
    return (
        <Field
            name="state" 
            component="select" 
            className="form-control form-control-alternative"
        >
            <option />
            <Query query={PORTAL_ESTABLISHMENTS_STATES_QUERY} variables={variables}>
                {({ loading, error, data }) => {
                    if (loading || error) return <Fragment />;
                    const { portalEstablishmentsStates } = data;
                    const options = portalEstablishmentsStates.states.map(state => (
                        <option
                            key={state}
                            value={state}
                        >
                        {state}
                        </option>
                    ));
                    return options;
                }}
            </Query>
        </Field>
    );
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(EstablishmentsStatesSelect);


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Filters/EstablishmentsStatesSelect.js